package com.dwarshb.bms

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.CheckCircleOutline
import androidx.compose.material.icons.filled.ContentCopy
import androidx.compose.material.icons.filled.Share
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.LocalClipboardManager
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.TextUnit
import androidx.compose.ui.unit.TextUnitType
import androidx.compose.ui.unit.dp

@Composable
 fun TripCreated(trip: Trip, onBackPressed: ()->Unit) {
    Column(modifier = Modifier.verticalScroll(rememberScrollState())) {
        AppIconTopBar {
            onBackPressed()
        }
        Card(modifier = Modifier.padding(24.dp)
            .background(
                shape = RoundedCornerShape(18.dp),
                brush = Brush.verticalGradient(
                    listOf(
                        Color(0xFF6A11CB),
                        Color(0xFF2575FC)
                    )
                )
            ),
            colors = CardDefaults.cardColors(containerColor = Color.Transparent)) {
            Column(modifier = Modifier.padding(24.dp)) {
                Icon(
                    Icons.Filled.CheckCircleOutline, "",
                    tint = Color.Green,
                    modifier = Modifier.size(48.dp)
                        .padding(bottom = 8.dp)
                        .align(Alignment.CenterHorizontally)
                )
                Text(
                    "Trip Created Successfully",
                    color = Color.White,
                    modifier = Modifier.align(Alignment.CenterHorizontally)
                )
                Spacer(modifier = Modifier.height(32.dp))
                TripReviewLayout(trip = trip,displayDetailsOnly = true)
                Text(
                    "Invite Code",
                    color = Color.White,
                    style = MaterialTheme.typography.titleMedium,
                    modifier = Modifier.align(Alignment.CenterHorizontally)
                )
                Box(modifier = Modifier.background(Color.White.copy(0.2f)).padding(16.dp)
                    .align(Alignment.CenterHorizontally)) {
                    Text(
                        trip.id,
                        maxLines = 1,
                        letterSpacing = TextUnit(8f, TextUnitType.Sp),
                        textAlign = TextAlign.Center,
                        modifier = Modifier.padding(8.dp),
                        style = MaterialTheme.typography.displayMedium,
                        color = Color.White
                    )
                }
                Spacer(modifier = Modifier.height(24.dp))

                val clipboardManager = LocalClipboardManager.current
                OutlinedButton(
                    onClick = {
                        clipboardManager.setText(AnnotatedString(trip.id))
                    },
                    colors = ButtonDefaults.buttonColors(containerColor = Color.Transparent,
                        contentColor = Color.White),
                    border = BorderStroke(1.dp, Color.White),
                    modifier = Modifier.align(Alignment.CenterHorizontally)
                ) {
                    Icon(Icons.Default.ContentCopy, "")
                    Spacer(modifier = Modifier.width(16.dp))
                    Text("Copy Invite Code",)
                }
                OutlinedButton(
                    onClick = {},
                    colors = ButtonDefaults.buttonColors(containerColor = Color.Transparent,
                        contentColor = Color.White),
                    border = BorderStroke(1.dp, Color.White),
                    modifier = Modifier.align(Alignment.CenterHorizontally)
                ) {
                    Icon(Icons.Default.Share, "")
                    Spacer(modifier = Modifier.width(16.dp))
                    Text("Share Invite Code")
                }
                Spacer(modifier = Modifier.height(24.dp))
                Text("Share this invite code with your passenger, so they can book the trip",
                    color = Color.White,
                    textAlign = TextAlign.Center,
                    modifier = Modifier.align(Alignment.CenterHorizontally))
            }
        }
    }
}